<template>
  <form ref="form">
    <h1>Create a Test</h1>
    <p>Create a specific test to deploy on a sub-section of your site's audience. Control for location, device, referrer, and many more attributes.</p>
    <p>All fields left blank will not be used to determine test segmentation.</p>
    <div class="row">
      <div class="input-box">
        <input type="text" name="name" @input="inputName" required />
        <label>Name<span class="star"></span></label>
      </div>
      <div class="input-box">
        <input type="text" name="label" ref="label" @input="preventLabelUpdate" required />
        <label>Label<span class="star"></span></label>
      </div>
      <div class="input-box half-size">
        <input type="number" name="proportion" value="" step="0.1" required>
        <label for="">Percent<span class="star"></span></label>
      </div>
    </div>
    <div class="row">
      <div class="input-box">
        <textarea name="description" required />
        <label>Description<span class="star"></span></label>
      </div>
    </div>
    <div class="row">
      <div class="input-box" id="locale-picker">
        <div class="pill-container">
          <div name="locale" contenteditable="true" class="input" style="height: 23px"></div>
        </div>
        <label>States<span class="star"></span></label>
      </div>
    </div>
    <div class="row">
      <div class="input-box" id="device-type">
        <div class="pill-container">
          <div name="device_type" contenteditable="true" class="input" style="height: 23px"></div>
        </div>
        <label>Device Type<span class="star"></span></label>
      </div>
      <div class="input-box" id="browser-type">
        <div class="pill-container">
          <div name="browser" contenteditable="true" class="input" style="height: 23px"></div>
        </div>
        <label>Browser Type<span class="star"></span></label>
      </div>
    </div>
    <div class="row">
      <div class="input-box input-box--checkbox">
        <input type="checkbox" name="payment_request" />
        <label>Payment Request</label>
        <label class="form-switch normal">
          <input type="checkbox" />
          <i></i>
          <div class="explain if-true">
            <only>Work on users with Payment Request support.</only>
          </div>
          <div class="explain if-false">
            <only>Work on users without Payment Request support.</only>
          </div>
        </label>
      </div>
      <div class="input-box input-box--checkbox">
        <input type="checkbox" name="is_subscriber" value="">
        <label for="">Is Subscriber</label>
        <label class="form-switch normal">
          <input type="checkbox" />
          <i></i>
          <div class="explain if-true">
            <only>Work on users who are a subscriber.</only>
          </div>
          <div class="explain if-false">
            <only>Work on users who aren't a subscriber.</only>
          </div>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="input-box" id="referrer-type">
        <div class="pill-container">
          <div name="referrer_type" contenteditable="true" class="input" style="height: 23px"></div>
        </div>
        <label>Referrer Type<span class="star"></span></label>
      </div>
    </div>
    <button class="white" type="button" @click="submit">Create Test</button>
  </form>
</template>

<script>
import utils from "@/js/utils.js";
import EventBus from '@/js/event-bus.js';

const registerInputPills = () => {
  utils.createInputPillTypeaheadPair({
    input_pills: $("#locale-picker .pill-container"),
    typeahead: $("#locale-picker"),
    typeahead_input: $("#locale-picker .pill-container .input"),
  }, {
    data: ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California',
      'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii',
      'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana',
      'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota',
      'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
      'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota',
      'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island',
      'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
      'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
    ],
  });

  utils.createInputPillTypeaheadPair({
    input_pills: $("#device-type .pill-container"),
    typeahead: $("#device-type"),
    typeahead_input: $("#device-type .pill-container .input"),
  }, {
    data: ['Windows', 'Mac', 'iPhone', 'Android', 'iPad'],
  });

  utils.createInputPillTypeaheadPair({
    input_pills: $("#browser-type .pill-container"),
    typeahead: $("#browser-type"),
    typeahead_input: $("#browser-type .pill-container .input"),
  }, {
    data: ['Chrome', 'Safari', 'Firefox', 'IE', 'Edge', 'Opera'],
  });

  utils.createInputPillTypeaheadPair({
    input_pills: $("#referrer-type .pill-container"),
    typeahead: $("#referrer-type"),
    typeahead_input: $("#referrer-type .pill-container .input"),
  }, {
    data: ['Social', 'Search', 'Email', 'Direct'],
  });
};
export default {
  name: `CreateTest`,
  data: function () {
    return {
      should_update_label: true,
    };
  },

  methods: {
    inputName: (() => {
      return function (e) {
        if (this.$data.should_update_label) {
          this.$refs.label.value = utils.nameToLabel(e.target.value);
        }
      };
    })(),

    preventLabelUpdate () {
      this.$data.should_update_label = false;
    },

    async submit () {
      let data = utils.getFormInput(this.$refs.form);

      data.proportion /= 100;
      data.locale = data.locale.map(o => utils.localeToCode(o));

      // emit this event to the general listener so that something can pick it
      // up (in this case the table, so we can create another row).
      EventBus.$emit("createTest", data);
    }
  },

  mounted () {
    registerInputPills();
  }
}
</script>

<style>
form {
  width: 600px;
  padding: 20px;
  background: #f3f4f7;
  margin: 0;

  border-radius: 5px;
}

textarea {
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/special/forms/CreateTest.vue